import React from 'react';
import BiteListReact from './BiteListReact';

const BiteList: React.FC = () => {
  return <BiteListReact />;
};

export default BiteList;
